import {
  Box,
  Button,
  Checkbox,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Paper,
  styled,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {
  CREATE_BOOKING,
  CREATE_CUSTOMER_SIDE_BOOKING,
  FIND_US_LIST,
  GET_BOOKING_DATA,
  GET_COMPANY_HOURS,
  GET_FREQUENCY_LIST,
  VALIDATE_CODE,
} from "../../api";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../../axios";
import LoginIcon from "@mui/icons-material/Login";
import PhoneIcon from "@mui/icons-material/Phone";
import Logo from "../../../assets/logo.png";
import CoverImage from "../../../assets/coverImage.png";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import * as Yup from "yup";
import { useFormik, Form, FormikProvider, Field, ErrorMessage } from "formik";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import * as _ from "lodash";
import { getItemEligibilityLabel, isItemEligible } from "../../utils/bookingItemEligibility";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-google-places-autocomplete";
import { LoadingButton } from "@mui/lab";
import {
  CardElement,
  Elements,
  ElementsConsumer,
} from "@stripe/react-stripe-js";
import { getTenantStripePromise } from "../../utils/stripe";
import { baseImageUrl, apiPathUrl } from "../../utils/config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AccessTime } from "@mui/icons-material";
import { renderItemDataOrEmptyNull } from "../../utils/utils";
import PhoneInput from 'react-phone-input-2';
import { ScrollToError } from "../../utils/scrollToError";
import { useLocation } from 'react-router-dom';
import BookingSelectionBreakdown from "../../components/BookingSelectionBreakdown";
import { tenantPublicPageUrl } from "../../utils/tenantApi";

const getItemDiscountAmount = (item) => {
  const discountValue = Number(
    item?.discount_value ?? item?.discount_amount ?? item?.discount_percent
  ) || 0;
  if (item?.discount_type === "fixed") return discountValue;
  return (discountValue * (Number(item?.price) || 0)) / 100;
};

const getSelectedDateValue = (value) =>
  value && moment(value).isValid() ? moment(value).format("YYYY-MM-DD") : "";

const MainBox = styled(Box)(({ theme }) => ({
  "& .topHeader": {
    position: "fixed",
    width: "100%",
    backgroundColor: "#fff",
    zIndex: "999",
    boxShadow:
      "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
    "& .logoContainer": {
      padding: "5px 0 2px 0",
      "& img": {
        width: "200px",
      },
    },
    "& .signInBtn": {
      color: "#3498db",
      fontSize: "1rem",
      fontWeight: "600",
    },
    "& .bodyTxt": {
      color: "#3498db",
      paddingRight: "0.3rem",
    },
  },
  "& .contentMain": {
    paddingTop: "8rem",
    "& .bookingTitle": {
      textAlign: "center",
      fontWeight: "bold",
      paddingBottom: "1rem",
      paddingTop: "1rem",
    },
    "& .coverImage": {
      width: "100%",
    },
    "& .tell-us": {},
    "& .subHeadings": {
      fontWeight: "bold",
      fontSize: "1.4rem",
      paddingTop: "1rem",
      paddingBottom: "1rem",
    },
  },
}));

const DateWrapper = styled("div")(() => ({
  "& .react-datepicker": {
    width: "100%",
    "& .react-datepicker__month-container": {
      width: "100%",
      "& .react-datepicker__day-names": {
        display: "flex",
        justifyContent: "space-evenly",
      },
      "& .react-datepicker__week": {
        display: "flex",
        justifyContent: "space-evenly",
      },
    },
  },
  "& .error": {
    fontWeight: 400,
    fontSize: "0.75rem",
    lineHeight: 1.66,
    letterSpacing: "0.03333em",
    textAlign: "left",
    marginTop: "4px",
    marginRight: "14px",
    marginBottom: 0,
    marginLeft: "14px",
    color: "#FF3D57",
  },
}));
const TimeWrapper = styled("div")(() => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "5px",
  "& .timeItemStyle": {
    border: "1px solid #3498db",
    borderRadius: "5px",
    cursor: "pointer",
    background: "rgb(52 152 219 / 15%)",
    padding: "6px 10px",
    width: "49%",
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    "& input": {
      marginTop: "0",
      cursor: "pointer",
    },
    '& input[type="radio"]': {
      webkitAppearance: "none",
      mozAppearance: "none",
      appearance: "none",
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      border: "1px solid #a3a4a4",
      backgroundColor: "white",
      outline: "none",
      marginRight: "6px",
      transition: "border-color 0.2s ease-in-out",
    },
    '& input[type="radio"]:checked': {
      backgroundColor: "#3498db",
      borderColor: "#3498db",
    },
    '& input[type="radio"]:checked::before': {
      content: '""',
      display: "block",
      width: "5px",
      height: "5px",
      borderRadius: "50%",
      backgroundColor: "white",
      position: "relative",
      top: "51%",
      left: "51%",
      transform: "translate(-50%, -50%)",
    },
    "& label": {
      cursor: "pointer",
    },
  },
  "& .timeSelected": {
    background: "rgb(52 152 219 / 25%)",
  },
  "& .error": {
    fontWeight: 400,
    fontSize: "0.75rem",
    lineHeight: 1.66,
    letterSpacing: "0.03333em",
    textAlign: "left",
    marginTop: "4px",
    marginRight: "14px",
    marginBottom: 0,
    marginLeft: "14px",
    color: "#FF3D57",
  },
}));

function Booking() {
  const stripePromise = useMemo(() => getTenantStripePromise(), []);
  const [stripe, setStripe] = useState(null);
  const [elements, setElements] = useState(null);
  const token = localStorage.getItem("accessToken");
  const userDetails = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [bookingData, setBookingData] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedExtras, setSelectedExtras] = useState([]);
  const [frequencyArray, setFrequencyArray] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [streetValue, setStreetValue] = useState(null);
  const addressGeocodeRequest = useRef(0);
  const packageFieldRefs = useRef([]);
  const [missingPackageIndexes, setMissingPackageIndexes] = useState([]);
  const [findUsList, setFindUsList] = useState([]);
  const [validDateTimeList, setValidDateTimeList] = useState({});
  const [promoDiscount, setPromoDiscount] = useState(null);
  const [giftCardCode, setGiftCardCode] = useState("");
  const [selectedMethod, setSelectedMethod] = useState("stripe");
  const [giftCardDiscount, setGiftCardDiscount] = useState(null);
  const [giftCardCodeModal, setGiftCardCodeModal] = useState(false);
  const streetTerms = streetValue?.value?.terms;
  const createBookingEndpoint = token || userDetails?.role === 'Customer' ? CREATE_CUSTOMER_SIDE_BOOKING : CREATE_BOOKING;
  const location = useLocation();
  const currentPath = location.pathname;
  const slug = currentPath.split('/').pop();
  const getMissingRequiredPackageIndexes = () =>
    (bookingData?.packages || [])
      .slice()
      .sort((a, b) => a.order - b.order)
      .reduce((missingIndexes, packageData, index) => {
        if (packageData?.item?.length > 0 && !selectedItems[index]?.id) {
          missingIndexes.push(index);
        }
        return missingIndexes;
      }, []);
  const validateRequiredPackages = () => {
    const missingIndexes = getMissingRequiredPackageIndexes();
    setMissingPackageIndexes(missingIndexes);
    if (missingIndexes.length) {
      const firstMissingField = packageFieldRefs.current[missingIndexes[0]];
      firstMissingField?.scrollIntoView({ behavior: "smooth", block: "center" });
      window.setTimeout(() => {
        firstMissingField
          ?.querySelector("input, [role='combobox']")
          ?.focus();
      }, 350);
      return false;
    }
    return true;
  };

  const getFrequencyList = async () => {
    const res = await axios.get(
      `${apiPathUrl}${GET_FREQUENCY_LIST}/`
    );
    setFrequencyArray(res?.data?.data || []);
  };
  const getFindUsList = async () => {
    await axios
      .get(`${apiPathUrl}${FIND_US_LIST}`)
      .then((res) => {
        setFindUsList(res?.data?.data);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    getFrequencyList();
    getFindUsList();
  }, []);

  useEffect(() => {
    const checkAndRedirect = async () => {
      if (token && userDetails?.role === 'Customer') {
        navigate(`/customerbook/${slug}`);
      } else if (token && userDetails?.role === 'Admin') {
        navigate('/dashboard/default', { state: { someKey: true, setStepOne: true } });
      }
    };
    checkAndRedirect();
  }, [navigate, slug, token, userDetails?.role]);

  const handleChangeAccordian = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const schema = Yup.object().shape({
    start_time: Yup.string().required("Start time is required!"),
    // .test('Time should be between 9 to 5', (value, { createError }) => {
    //   if (+value?.split(':')[0] < 9 || +value?.split(':')[0] > 17) {
    //     return createError({ message: 'Time should be between 9 to 5' });
    //   }
    //   if (+value?.split(':')[0] === 17 && +value?.split(':')[1] > 0) {
    //     return createError({ message: 'Time should be between 9 to 5' });
    //   }
    //   return true;
    // }),
    start_date: Yup.string().required("Start date is required!"),
    first_name: Yup.string()
      .trim()
      .matches(/^[A-Za-z][A-Za-z\s'-]*$/, "Enter a valid first name")
      .required("First name is required!"),
    last_name: Yup.string()
      .trim()
      .matches(/^[A-Za-z][A-Za-z\s'-]*$/, "Enter a valid last name")
      .required("Last name is required!"),
    email: Yup.string()
      .email("Enter proper email address!")
      .required("Email is required!"),
    phone: Yup.string()
      .required("Phone no is required!")
      .test("valid-phone", "Enter a valid phone number!", (value) => {
        const digits = String(value || "").replace(/\D/g, "");
        return digits.length >= 10 && digits.length <= 15;
      }),
    street_address: Yup.string().required("Street address is required!"),
    city: Yup.string().required("City is required!"),
    state: Yup.string().required("State is required!"),
    zip_code: Yup.string()
      .trim()
      .matches(/^\d{5}(?:-\d{4})?$/, "Enter a valid ZIP code!")
      .required("Zip Code is required!"),
    // additional_info: Yup.string().required('Additional information is required!'),
    // customer_notes: Yup.string().required('Customer notes are required!'),
    how_to_enter_on_premise: Yup.string().required('This field is required!'),
    do_you_pets: Yup.string().required("Select an option!"),
    // card_token: Yup.string().required('Card details are required!'),
    cardHolderName: selectedMethod === 'stripe' && Yup.string().required("Card holder name is required!"),
    package_selection: Yup.string().required("Select minimum 1 package!"),
  });

  const formik = useFormik({
    initialValues: {
      start_time: "",
      start_date: "",
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      street_address: "",
      apt_suite: "",
      city: "",
      state: "",
      zip_code: "",
      hear_about_us: "",
      promo_code: localStorage.getItem("promoCodeForBooking") || "",
      additional_info: "",
      how_to_enter_on_premise: "",
      card_token: "",
      package_selection: "",
      // customer_notes: '',
      frequency: "",
      latitude: "",
      cardHolderName: "",
      longitude: "",
      do_parking_spot: false,
      do_you_pets: "",
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      if (!validateRequiredPackages()) return;

      const hasValidCoordinates =
        values?.latitude !== null &&
        values?.latitude !== "" &&
        values?.longitude !== null &&
        values?.longitude !== "" &&
        Number.isFinite(Number(values?.latitude)) &&
        Number.isFinite(Number(values?.longitude));
      if (!hasValidCoordinates) {
        toast.error("Please select a valid service address before booking.");
        return;
      }

      if (!availableTimes.some((slot) => slot.value === values.start_time)) {
        setFieldTouched("start_time", true, false);
        setFieldError("start_time", "Select an available time for the chosen date!");
        toast.error("Please select an available time for the chosen date.");
        return;
      }

      setLoading(true);
      try {
        if (stripe && elements && selectedMethod === "stripe") {
          const cardElement = elements.getElement(CardElement);
          const result = await stripe.createToken(cardElement, {
            name: values.cardHolderName,
          });
          if (result.error) {
            setLoading(false);
            toast.error(result.error.message);
            setFieldValue("card_token", "");
          } else {
            toast.success("Card successfully applied!");
            setFieldValue("card_token", result.token.id);
            const itemMapData = _.compact(selectedItems).map((item) => {
              return { item_id: item?.id, package: item?.packageData };
            });
            const objToSend = {
              contact_info: {
                first_name: values?.first_name,
                last_name: values?.last_name,
                email: values?.email,
                phone: values?.phone,
                how_to_enter_on_premise: values?.how_to_enter_on_premise,
                do_parking_spot: values?.do_parking_spot,
                "do_you_pets": values?.do_you_pets,
                "how_do_you_hear_about_us": values?.hear_about_us,
              },
              service_location: {
                street_address: values?.street_address,
                apt_suite: values?.apt_suite,
                city: values?.city,
                state: values?.state,
                zip_code: values?.zip_code,
                let_long: "",
              },
              extras: _.compact(selectedExtras),
              items: itemMapData,
              booking_type: values?.frequency,
              service_id: bookingData?.id,
              start_time: values?.start_time || "",
              start_date: getSelectedDateValue(values?.start_date),
              additional_info: values?.additional_info,
              card_token: selectedMethod === 'zelle' ? 'ZILLE' : (values?.card_token || result.token.id),
              // customer_notes: values?.customer_notes,
              latitude: values?.latitude,
              longitude: values?.longitude,
              how_do_you_hear_about_us: values?.hear_about_us,
              source:
                token || userDetails?.role === "Customer"
                  ? "Web-App"
                  : "Web-Link",
            };
            if (giftCardDiscount && giftCardCode) {
              objToSend["gift_card"] = giftCardCode;
            }
            if (promoDiscount && values?.promo_code) {
              objToSend["promo_code"] = values.promo_code;
            }
            localStorage.setItem(
              "allBookingdata",
              JSON.stringify({
                ...objToSend,
                company: bookingData?.company,
              })
            );
            toast.promise(
              axios.post(
                `${apiPathUrl}${createBookingEndpoint}/${bookingData?.id}`,
                objToSend,
                {
                  headers: { "Content-Type": "application/json" },
                }
              ),
              {
                loading: () => {
                  return `Creating Booking!`;
                },
                success: (res) => {
                  localStorage.removeItem("promoCodeForBooking");
                  setLoading(false);
                  const stateToPass = {
                    bookingData: { ...objToSend, booking_id: res?.data?.data?.booking_id || res?.data?.data?.booking },
                    checkoutData: {
                      selectedExtras,
                      values,
                      availableTimes,
                      selectedItems,
                      estimatedTax,
                      promoDiscount,
                      giftCardDiscount,
                      todaysTotal,
                      codesDiscount,
                    }
                  };
                  let confirmBookingRoute = tenantPublicPageUrl(selectedMethod === 'zelle' ? 'zelle-checkout' : 'confirm-booking');
                  // setTimeout(() => {
                  //   navigate(
                  //     let confirmBookingRoute = token === null ? "/session/signup" : "/confirmBooking"
                  //   );
                  // }, 500);
                  setTimeout(() => {
                    navigate(confirmBookingRoute, { state: stateToPass });
                  }, 500);
                  return res?.data?.message;
                },
                error: (err) => {
                  setLoading(false);
                  return err?.response?.data?.message || err?.message;
                },
              }
            );
          }
        } else {

          const itemMapData = _.compact(selectedItems).map((item) => {
            return { item_id: item?.id, package: item?.packageData };
          });
          const objToSend = {
            contact_info: {
              first_name: values?.first_name,
              last_name: values?.last_name,
              email: values?.email,
              phone: values?.phone,
              how_to_enter_on_premise: values?.how_to_enter_on_premise,
              do_parking_spot: values?.do_parking_spot,
              "do_you_pets": values?.do_you_pets,
              "how_do_you_hear_about_us": values?.hear_about_us,
            },
            service_location: {
              street_address: values?.street_address,
              apt_suite: values?.apt_suite,
              city: values?.city,
              state: values?.state,
              zip_code: values?.zip_code,
              let_long: "",
            },
            extras: _.compact(selectedExtras),
            items: itemMapData,
            booking_type: values?.frequency,
            service_id: bookingData?.id,
            start_time: values?.start_time || "",
            start_date: getSelectedDateValue(values?.start_date),
            additional_info: values?.additional_info,
            card_token: selectedMethod === 'zelle' ? 'ZILLE' : values?.card_token,
            // customer_notes: values?.customer_notes,
            latitude: values?.latitude,
            longitude: values?.longitude,
            how_do_you_hear_about_us: values?.hear_about_us,
            source:
              token || userDetails?.role === "Customer"
                ? "Web-App"
                : "Web-Link",
          };
          if (giftCardDiscount && giftCardCode) {
            objToSend["gift_card"] = giftCardCode;
          }
          if (promoDiscount && values?.promo_code) {
            objToSend["promo_code"] = values.promo_code;
          }
          localStorage.setItem(
            "allBookingdata",
            JSON.stringify({
              ...objToSend,
              company: bookingData?.company,
            })
          );
          toast.promise(
            axios.post(
              `${apiPathUrl}${createBookingEndpoint}/${bookingData?.id}`,
              objToSend,
              {
                headers: { "Content-Type": "application/json" },
              }
            ),
            {
              loading: () => {
                return `Creating Booking!`;
              },
              success: (res) => {
                localStorage.removeItem("promoCodeForBooking");
                setLoading(false);
                const stateToPass = {
                  bookingData: { ...objToSend, booking_id: res?.data?.data?.booking_id || res?.data?.data?.booking },
                  checkoutData: {
                    selectedExtras,
                    values,
                    availableTimes,
                    selectedItems,
                    estimatedTax,
                    promoDiscount,
                    giftCardDiscount,
                    todaysTotal,
                    codesDiscount,
                  }
                };
                let confirmBookingRoute = tenantPublicPageUrl(selectedMethod === 'zelle' ? 'zelle-checkout' : 'confirm-booking');
                setTimeout(() => {
                  navigate(confirmBookingRoute, { state: stateToPass });
                }, 500);

                return res?.data?.message;
              },
              error: (err) => {
                setLoading(false);
                return err?.response?.data?.message || err?.message;
              },
            }
          );
        }
      } catch (error) {
        console.log("in error", error);
        setLoading(false);
      }
    },
  });

  const {
    errors,
    touched,
    setFieldValue,
    setFieldError,
    setFieldTouched,
    handleSubmit,
    getFieldProps,
    values,
  } = formik;
  const handleBookingFormSubmit = (event) => {
    event.preventDefault();
    if (validateRequiredPackages()) handleSubmit(event);
  };

  useEffect(() => {
    if (streetTerms?.length) {
      const state = streetTerms[streetTerms.length - 2];
      const city = streetTerms[streetTerms.length - 3];
      setFieldValue("state", state?.value || "");
      setFieldValue("city", city?.value || "");
    }
  }, [setFieldValue, streetTerms]);
  useEffect(() => {
    const callApi = async () => {
      await axios
        .get(`${apiPathUrl}${GET_BOOKING_DATA}/${slug}`)
        .then((res) => {
          const data = res?.data?.data;
          const packages = (data?.packages || [])
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((packageData) => ({
              ...packageData,
              item: (packageData.item || [])
                .slice()
                .sort((a, b) => a.id - b.id)
                .map((item) => ({ ...item, packageData: packageData.id })),
            }));
          setBookingData({ ...data, packages });
          setSelectedItems([]);
        })
        .catch((err) => console.error(err));
    };
    callApi();
  }, [setFieldValue, slug]);
  useEffect(() => {
    if (bookingData?.company) {
      axios
        .get(
          `${apiPathUrl}${GET_COMPANY_HOURS}/${bookingData?.company}/`
        )
        .then((res) => {
          setValidDateTimeList(res?.data);
        })
        .catch((err) => console.log("err", GET_COMPANY_HOURS, err));
    }
  }, [bookingData?.company]);

  const handleSelectPackageData = (value, index, packageData) => {
    if (value && !isItemEligible(value, bookingData?.is_first_booking)) return;
    const dupArr = [...selectedItems];
    dupArr[index] = value;

    if (value !== null) {
      dupArr[index].packageData = packageData?.id;
      setFieldValue("package_selection", value.title);
    } else if (!dupArr.some((iData) => iData?.id)) {
      setFieldValue("package_selection", "");
    }
    setSelectedItems(dupArr);
  };
  const handleExtrasClick = (data, index) => {
    const dupArr = [...selectedExtras];
    if (selectedExtras[index]?.quantity) {
      dupArr[index] = undefined;
      setSelectedExtras(dupArr);
    } else {
      dupArr[index] = {
        extra_id: data.id,
        quantity: 1,
        price: data?.price,
        time_hrs: data?.time_hrs,
      };
      setSelectedExtras(dupArr);
    }
  };
  const handleDecrement = (index) => {
    const dupArr = [...selectedExtras];
    if (dupArr[index].quantity > 1) {
      dupArr[index].quantity = dupArr[index].quantity - 1;
      setSelectedExtras(dupArr);
    }
  };
  const handleIncrement = (index) => {
    const dupArr = [...selectedExtras];
    dupArr[index].quantity = dupArr[index].quantity + 1;
    setSelectedExtras(dupArr);
  };

  const handleValidateGiftCard = () => {
    const data = {
      code: giftCardCode,
      service: bookingData?.id,
    };
    toast.promise(
      axios.post(`${apiPathUrl}${VALIDATE_CODE}`, data, {
        headers: { "Content-Type": "application/json" },
      }),
      {
        loading: () => {
          return `Validating Gift Card Code!`;
        },
        success: (res) => {
          setGiftCardDiscount(res?.data?.data?.amount);
          setGiftCardCodeModal(false);
          return res?.data?.message;
        },
        error: (err) => {
          setGiftCardCodeModal(false);
          return err?.message;
        },
      }
    );
  };
  const handleValidatePromo = () => {
    const data = {
      code: values.promo_code,
      service: bookingData?.id,
    };
    toast.promise(
      axios.post(`${apiPathUrl}${VALIDATE_CODE}`, data, {
        headers: { "Content-Type": "application/json" },
      }),
      {
        loading: () => {
          return `Validating Promo Code!`;
        },
        success: (res) => {
          setPromoDiscount(res?.data?.data?.amount);
          return res?.data?.message;
        },
        error: (err) => {
          return err?.message;
        },
      }
    );
  };
  useEffect(() => {
    if (!streetValue?.label) return;

    const requestId = ++addressGeocodeRequest.current;
    setFieldValue("street_address", streetValue.label);
    setFieldValue("latitude", "");
    setFieldValue("longitude", "");
    geocodeByAddress(streetValue.label)
      .then(async (results) => {
        const result = results[0];
        const coordinates = await getLatLng(result);
        return { result, coordinates };
      })
      .then(({ result, coordinates: { lat, lng } }) => {
        if (addressGeocodeRequest.current !== requestId) return;
        const components = result?.address_components || [];
        const getAddressComponent = (types, useShortName = false) => {
          const component = components.find((item) =>
            types.some((type) => item.types?.includes(type))
          );
          return component
            ? component[useShortName ? "short_name" : "long_name"]
            : "";
        };

        const city = getAddressComponent([
          "locality",
          "postal_town",
          "sublocality",
        ]);
        const state = getAddressComponent(
          ["administrative_area_level_1"],
          true
        );
        const zipCode = getAddressComponent(["postal_code"]);

        setFieldValue("city", city);
        setFieldValue("state", state);
        setFieldValue("zip_code", zipCode);
        setFieldValue("latitude", lat);
        setFieldValue("longitude", lng);
      })
      .catch((error) => {
        if (addressGeocodeRequest.current !== requestId) return;
        setFieldValue("latitude", "");
        setFieldValue("longitude", "");
        console.error("Unable to resolve service address coordinates", error);
      });
  }, [setFieldValue, streetValue]);

  const CARD_ELEMENT_OPTIONS = {
    style: {
      base: {
        border: "1px solid gray",
        color: "#303238",
        fontSize: "16px",
        fontFamily: "sans-serif",
        fontSmoothing: "antialiased",
        "::placeholder": {
          color: "#818082",
        },
      },
      invalid: {
        color: "#e5424d",
        ":focus": {
          color: "#303238",
        },
      },
    },
  };

  const validDates = validDateTimeList
    ? Object.keys(validDateTimeList)
        .map((dateStr) => moment(dateStr, "YYYY-MM-DD", true))
        .filter((date) => date.isValid())
        .map((date) => date.toDate())
    : [];
  const filterDates = (date) => {
    return validDates.some(
      (validDate) => validDate.toDateString() === date.toDateString()
    );
  };
  // Function to convert 12-hour format to 24-hour format using moment.js
  const convertTo24HourFormat = (time) => {
    const timeMoment = moment(time, "hh:mm A");
    return timeMoment.format("HH:mm");
  };
  const availableTimes = useMemo(() => {
    if (values.start_date) {
      return validDateTimeList[
        `${moment(values.start_date)?.format("YYYY-MM-DD")}`
      ]?.map((z) => {
        return {
          label: z,
          value: convertTo24HourFormat(z),
        };
      });
    } else {
      return [];
    }
  }, [values.start_date, validDateTimeList]);
  const selectedBookingItems = _.compact(selectedItems);
  const selectedBookingExtras = _.compact(selectedExtras);
  const itemSubtotal = selectedBookingItems.reduce(
    (total, item) => total + (Number(item?.price) || 0),
    0
  );
  const itemDiscountTotal = selectedBookingItems.reduce(
    (total, item) => total + getItemDiscountAmount(item),
    0
  );
  const extrasTotal = selectedBookingExtras.reduce(
    (total, item) =>
      total + (Number(item?.price) || 0) * (Number(item?.quantity) || 0),
    0
  );
  const totalValue = Math.max(0, itemSubtotal - itemDiscountTotal + extrasTotal);
  const estimatedTax =
    ((Number(bookingData?.tax?.[0]?.tax_rate) || 0) / 100) * totalValue;
  const todaysTotal = estimatedTax + totalValue;
  const codesDiscount = (promoDiscount || 0) + (giftCardDiscount || 0);
  const finalTotal = Math.max(0, todaysTotal - codesDiscount);
  const totalHours =
    selectedBookingItems.reduce(
      (total, item) => total + (Number(item?.time_hrs) || 0),
      0
    ) +
    selectedBookingExtras.reduce(
      (total, item) =>
        total + (Number(item?.time_hrs) || 0) * (Number(item?.quantity) || 0),
      0
    );
  return (
    <MainBox>
      <Box className="topHeader">
        <Container maxWidth="lg">
          <Box
            display={"flex"}
            alignItems="center"
            justifyContent={"space-between"}
          >
            <Box className="logoContainer">
              <a href="/dashboard/default">
                <img
                  src={Logo}
                  alt="logo"
                  className="logoImg"
                  style={{ cursor: "pointer" }}
                />
              </a>
            </Box>
            <Box display={"flex"} alignItems="center">
              <Box display={"flex"} alignItems="center">
                <PhoneIcon className="bodyTxt" />
                <Typography
                  variant="body1"
                  className="bodyTxt"
                  style={{ cursor: "pointer" }}
                >
                  <a href="tel:+12128516134">+1(212)851-6134</a>
                </Typography>
              </Box>
              <Box
                display={"flex"}
                alignItems="center"
                sx={{ marginLeft: "1rem" }}
              >
                <Button
                  variant="text"
                  startIcon={<LoginIcon />}
                  onClick={() => navigate(`/session/signin`)}
                  className="signInBtn"
                >
                  Customer Sign in
                </Button>
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>

      <Container maxWidth="lg" className="contentMain">
        <Grid container columnSpacing={4}>
          <Grid item xs={8}>
            <Box
              sx={{
                background: "white",
                padding: "1rem",
                paddingTop: "2rem",
                width: "100%",
                border: "1px solid #dddada",
                textAlign: "center",
                "& a": {
                  "&:hover": {
                    textDecoration: "underline",
                  },
                },
              }}
            >
              <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={handleBookingFormSubmit}>
                  <ScrollToError />
                  <Typography
                    variant="h4"
                    className="bookingTitle"
                    sx={{
                      textTransform: "capitalize",
                      fontSize: "1.75rem !important",
                    }}
                  >
                    {bookingData?.name}
                  </Typography>
                  <img src={CoverImage} alt="cover" className="coverImage" />
                  <Typography
                    variant="h4"
                    className="bookingTitle"
                    sx={{
                      fontSize: "1.75rem !important",
                      fontWeight: "500 !important",
                      paddingBottom: "5px !important",
                    }}
                  >
                    Booking in just 60 seconds!
                  </Typography>
                  <a
                    style={{
                      color: "#0275d8",
                      fontSize: "18px",
                      textAlign: "center",
                    }}
                    href="https://www.BookCleany.com"
                  >
                    www.BookCleany.com
                  </a>
                  <Divider sx={{ paddingTop: "2rem" }} />
                  <Box className="tell-us">
                    <Typography
                      variant="h4"
                      className="subHeadings"
                      sx={{ textAlign: "start !important" }}
                    >
                      Step 1: Tell us about the cleaning
                    </Typography>
                    <Grid container spacing={3}>
                      {bookingData?.packages?.length > 0 &&
                        bookingData?.packages
                          ?.slice()
                          ?.sort((a, b) => a.order - b.order)
                          ?.map((data, index) => (
                            <React.Fragment key={data?.id ?? `package-${index}`}>
                              <Grid
                                item
                                xs={12}
                                md={data?.title?.length > 40 ? 12 : 5}
                              >
                                <Typography sx={{ fontSize: "20px", textAlign: "start" }}>
                                  {data?.title}
                                </Typography>
                              </Grid>
                              {data?.title?.length > 40 && (
                                <Grid
                                  item
                                  md={5}
                                  sx={{ display: { xs: "none", md: "block" } }}
                                />
                              )}
                              <Grid item xs={12} md={7}>
                                <TextField
                                  ref={(node) => {
                                    packageFieldRefs.current[index] = node;
                                  }}
                                  fullWidth
                                  size="small"
                                  type="text"
                                  select
                                  value={selectedItems[index]}
                                  onChange={(e) => {
                                    handleSelectPackageData(
                                      e.target.value,
                                      index,
                                      data
                                    );
                                    setMissingPackageIndexes((current) =>
                                      current.filter((missingIndex) => missingIndex !== index)
                                    );
                                  }}
                                  name="package_selection"
                                  error={Boolean(
                                    missingPackageIndexes.includes(index) ||
                                    (touched.package_selection &&
                                      errors.package_selection)
                                  )}
                                  helperText={
                                    missingPackageIndexes.includes(index)
                                      ? "Select an option for this required package!"
                                      : touched.package_selection &&
                                        errors.package_selection
                                  }
                                >
                                  {data?.item?.length > 0 ? data?.item
                                      ?.sort((a, b) => a.id - b.id)
                                      ?.map((item) => (
                                        <MenuItem
                                          key={item?.id}
                                          value={item}
                                          disabled={!isItemEligible(item, bookingData?.is_first_booking)}
                                        >
                                          {item?.title}
                                          {item?.eligibility_type && item.eligibility_type !== 'all'
                                            ? ` — ${getItemEligibilityLabel(item.eligibility_type)}`
                                            : ''}
                                        </MenuItem>
                                      )) : (
                                        <MenuItem disabled>No items yet</MenuItem>
                                      )}
                                </TextField>
                              </Grid>
                            </React.Fragment>
                          ))}
                      <Grid item xs={12} md={5}>
                        <Typography sx={{ fontSize: "20px", textAlign: "start" }}>
                          Do you have pets?*
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          fullWidth
                          type="text"
                          select
                          size="small"
                          value={values.do_you_pets}
                          name='do_you_pets'
                          onChange={(e) => setFieldValue('do_you_pets', e.target.value)}
                          error={Boolean(touched.do_you_pets && errors.do_you_pets)}
                          helperText={touched.do_you_pets && errors.do_you_pets}
                        >
                          <MenuItem value={"no pet"}>No Pet</MenuItem>
                          <MenuItem value={"Cat"}>Cat</MenuItem>
                          <MenuItem value={"Dog"}>Dog</MenuItem>
                          <MenuItem value={"Both"}>Both</MenuItem>
                          <MenuItem value={"Other"}>Other</MenuItem>
                        </TextField>
                      </Grid>
                    </Grid>
                    <Divider sx={{ marginTop: "2rem" }} />
                    <Typography
                      variant="h4"
                      className="subHeadings"
                      sx={{ textAlign: "start !important" }}
                    >
                      Step 2: Any Extras?
                    </Typography>
                    <Typography
                      variant="body1"
                      style={{ paddingBottom: "1rem", textAlign: "start" }}
                    >
                      Select the extras you require for your booking. Price per
                      cleaning:
                    </Typography>
                    <Grid container spacing={5} sx={{ paddinTop: "1rem" }}>
                      {bookingData?.extras?.length > 0 &&
                        bookingData?.extras
                          ?.slice()
                          ?.sort((a, b) => a.order - b.order)
                          ?.map((data, index) => (
                            <Grid item xs={4}>
                              <Box sx={{ width: "100%", height: "100%" }}>
                                <Box
                                  sx={{
                                    width: "100%",
                                    height: "150px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    color: "#212529",
                                    backgroundColor: selectedExtras[index]?.quantity
                                      ? "#d3d9df"
                                      : "#f8f9fa",
                                    borderColor: selectedExtras[index]?.quantity
                                      ? "#d3d9df"
                                      : "#f8f9fa",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    "&:hover": {
                                      backgroundColor: "#d3d9df",
                                      borderColor: "#d3d9df",
                                    },
                                    "& h3": {
                                      marginTop: "5px",
                                      marginBottom: "unset",
                                    },
                                  }}
                                  onClick={() => handleExtrasClick(data, index)}
                                >
                                  <Box>
                                    <img
                                      style={{
                                        width: "5rem",
                                        height: "5rem",
                                        borderRadius: "50%",
                                        background: "white",
                                        border: "2px solid white",
                                      }}
                                      src={`${baseImageUrl}${data?.image_12}`}
                                      alt="extras images"
                                    />
                                  </Box>
                                  <h3>
                                    {data?.title}
                                    <Tooltip
                                      title={renderItemDataOrEmptyNull(
                                        data?.tool_tip
                                      )}
                                    >
                                      <HelpOutlineIcon
                                        style={{ fontSize: "15px" }}
                                      />
                                    </Tooltip>
                                  </h3>
                                </Box>
                                {selectedExtras[index]?.quantity && (
                                  <Box
                                    sx={{
                                      width: "100%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      padding: "10px",
                                      backgroundColor: "#d3d9df",
                                      borderColor: "#d3d9df",
                                    }}
                                  >
                                    <RemoveCircleOutlineIcon
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => handleDecrement(index)}
                                    />
                                    <Box
                                      sx={{
                                        marginLeft: "5px",
                                        marginRight: "5px",
                                        width: "4rem",
                                        textAlign: "center",
                                        background: "white",
                                        fontSize: "1rem",
                                        border: "1px solid black",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      {selectedExtras[index]?.quantity}
                                    </Box>
                                    <AddCircleOutlineIcon
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => handleIncrement(index)}
                                    />
                                  </Box>
                                )}
                              </Box>
                            </Grid>
                          ))}
                    </Grid>

                    <Divider sx={{ marginTop: "2rem" }} />
                    <Typography
                      variant="h4"
                      className="subHeadings"
                      sx={{ textAlign: "start !important" }}
                    >
                      Step 3: Choose your frequency
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ textAlign: "start !important" }}
                    >
                      You can always adjust the frequency, reschedule, or postpone
                      cleanings.
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        marginTop: "1.5rem",
                        "& button": {
                          borderRadius: " 15px 0px",
                          padding: "1rem 1.3rem",
                          fontSize: "1rem",
                          "&:hover": {
                            background: "#1976d2",
                            color: "white",
                          },
                        },
                      }}
                      gap={3}
                    >
                      <Field name="frequency">
                        {({ field }) =>
                          frequencyArray?.map((data, index) => (
                            <Button
                              size="large"
                              {...field}
                              key={index}
                              variant="outlined"
                              onClick={() => setFieldValue('frequency', data.type)}
                              sx={{
                                background: values?.frequency === data.type ? "#1976d2" : "",
                                color: values?.frequency === data.type ? "white" : "",
                              }}
                            >
                              {data?.title}&nbsp;{data?.offers?.title ? `(${data?.offers?.title})` : ''}
                            </Button>
                          ))}
                      </Field>
                    </Box>
                    {values?.frequency !== "once" && (
                      <>
                        <Typography
                          fontSize={"14px"}
                          color={"#8a94a9"}
                          marginTop={"20px"}
                        >{`The Cleany Loyalty discount will be applied on the second cleaning service and onwards. You can always make updates or changes in your online portal or reach out to our customer representative who can assist.`}</Typography>
                        <Box
                          display="flex"
                          alignItems={"center"}
                          justifyContent="space-between"
                        >
                          <Typography variant="h6" className="subHeadings">
                            Get more savings
                          </Typography>
                          <Button
                            variant="text"
                            color="inherit"
                            startIcon={<SavedSearchIcon />}
                          >
                            How it works
                          </Button>
                        </Box>

                        <Typography variant="body1">
                          The Cleany Happiness Guarantee applies to all bookings.
                          When you commit to a longer term plan, you will save more.
                        </Typography>
                      </>
                    )}

                    <Divider sx={{ marginTop: "2rem" }} />

                    <Typography
                      variant="h4"
                      className="subHeadings"
                      sx={{ textAlign: "start !important" }}
                    >
                      Step 4: Select a Date and Time
                    </Typography>
                    <Grid container spacing={5}>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Date<span style={{ color: "red" }}>*</span>
                        </h3>
                        <DateWrapper>
                          <DatePicker
                            {...getFieldProps("start_date")}
                            selected={values.start_date}
                            onChange={(date) => {
                              setFieldValue("start_date", date);
                              setFieldValue("start_time", "");
                            }}
                            inline
                            filterDate={filterDates}
                            error={Boolean(
                              touched.start_date && errors.start_date
                            )}
                            helperText={touched.start_date && errors.start_date}
                          />
                          <ErrorMessage
                            name="start_date"
                            component="div"
                            className="error"
                          />
                        </DateWrapper>
                        {/* <TextField
                          size="small"
                          fullWidth
                          type="date"
                          inputProps={{ min: `${moment(new Date()).format('YYYY-MM-DD')}` }}
                          {...getFieldProps('start_date')}
                          error={Boolean(touched.start_date && errors.start_date)}
                          helperText={touched.start_date && errors.start_date}
                        /> */}
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Time<span style={{ color: "red" }}>*</span>
                        </h3>
                        <TimeWrapper>
                          {availableTimes?.length ? (
                            <Field name="start_time">
                              {({ field }) =>
                                availableTimes.map((option) => (
                                  <div
                                    key={option.value}
                                    className={`${field.value === option.value
                                      ? "timeItemStyle timeSelected"
                                      : "timeItemStyle"
                                      }`}
                                    onClick={() =>
                                      setFieldValue("start_time", option.value)
                                    }
                                  >
                                    <input
                                      type="radio"
                                      id={option.value}
                                      {...field}
                                      value={option.value}
                                      checked={field.value === option.value}
                                    />
                                    <label htmlFor={option.value}>
                                      {option.label}
                                    </label>
                                  </div>
                                ))
                              }
                            </Field>
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                color: "#a3a4a4",
                                padding: "40px 0",
                              }}
                            >
                              <AccessTime style={{ fontSize: "30px" }} />
                              <p>Please select a date first.</p>
                            </div>
                          )}
                          <ErrorMessage
                            name="start_time"
                            component="div"
                            className="error"
                          />
                        </TimeWrapper>
                        {/* <TextField
                          size="small"
                          fullWidth
                          inputProps={{
                            min: '9:00',
                            max: '17:00',
                          }}
                          type="time"
                          {...getFieldProps('start_time')}
                          error={Boolean(touched.start_time && errors.start_time)}
                          helperText={touched.start_time && errors.start_time}
                        /> */}
                      </Grid>
                    </Grid>
                    <Box>
                      <Paper sx={{
                        padding: '15px',
                        marginTop: '15px',
                      }}>
                        Appointment reservation is for the hourly time window selected (example: 12pm slot ~ 12pm-1pm arrival). Please note this is a request and you will receive an auto confirmation. Charges are processed on the day of booking. We will reach out within 24 hours of your request if any changes or updates. Same day bookings please email or call customer service to assist - subject to availability.
                      </Paper>
                    </Box>
                    <Divider sx={{ marginTop: "2rem" }} />
                    <Typography
                      variant="h6"
                      className="subHeadings"
                      sx={{ textAlign: "start !important" }}
                    >
                      Step 5: Service Address
                    </Typography>
                    <Grid container rowSpacing={2} columnSpacing={5}>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          First Name<span style={{ color: "red" }}>*</span>
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="text"
                          inputProps={{ placeholder: "First name" }}
                          {...getFieldProps("first_name")}
                          error={Boolean(
                            touched.first_name && errors.first_name
                          )}
                          helperText={touched.first_name && errors.first_name}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Last Name<span style={{ color: "red" }}>*</span>
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="text"
                          inputProps={{ placeholder: "Last name" }}
                          {...getFieldProps("last_name")}
                          error={Boolean(touched.last_name && errors.last_name)}
                          helperText={touched.last_name && errors.last_name}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Street Address<span style={{ color: "red" }}>*</span>
                        </h3>
                        <GooglePlacesAutocomplete
                          apiKey="AIzaSyD7Y6D1Vbeyy6_-2nYEpNdqUaLoXaf7EXs"
                          fetchDetails={true}
                          selectProps={{
                            value: streetValue,
                            onChange: (address) => {
                              addressGeocodeRequest.current += 1;
                              setStreetValue(address);
                              setFieldValue("latitude", "");
                              setFieldValue("longitude", "");
                            },
                          }}
                        />
                        <span
                          style={{
                            fontWeight: 400,
                            fontSize: "0.75rem",
                            lineHeight: 1.66,
                            letterSpacing: "0.03333em",
                            textAlign: "left",
                            marginTop: "4px",
                            marginRight: "14px",
                            marginBottom: "0",
                            marginLeft: "14px",
                            color: "#FF3D57",
                          }}
                        >
                          {Boolean(
                            touched.street_address && errors.street_address
                          )
                            ? touched.street_address && errors.street_address
                            : null}
                        </span>

                        {/* <TextField
                          size="small"
                          fullWidth
                          type="text"
                          sx={{ visibility: 'hidden' }}
                          inputProps={{ placeholder: '1234 Main St' }}
                          {...getFieldProps('street_address')}
                          error={Boolean(touched.street_address && errors.street_address)}
                          helperText={touched.street_address && errors.street_address}
                        /> */}
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Apt # (optional)
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="text"
                          inputProps={{
                            placeholder: "Apartment, Studio or Floor",
                          }}
                          {...getFieldProps("apt_suite")}
                          error={Boolean(touched.apt_suite && errors.apt_suite)}
                          helperText={touched.apt_suite && errors.apt_suite}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          City<span style={{ color: "red" }}>*</span>
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="text"
                          {...getFieldProps("city")}
                          error={Boolean(touched.city && errors.city)}
                          helperText={touched.city && errors.city}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          State<span style={{ color: "red" }}>*</span>
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="text"
                          {...getFieldProps("state")}
                          error={Boolean(touched.state && errors.state)}
                          helperText={touched.state && errors.state}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Zip Code<span style={{ color: "red" }}>*</span>
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="number"
                          {...getFieldProps("zip_code")}
                          error={Boolean(touched.zip_code && errors.zip_code)}
                          helperText={touched.zip_code && errors.zip_code}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Phone Number<span style={{ color: "red" }}>*</span>
                        </h3>
                        {/* <TextField
                          size="small"
                          fullWidth
                          type="text"
                          {...getFieldProps("phone")}
                          error={Boolean(touched.phone && errors.phone)}
                          helperText={touched.phone && errors.phone}
                        /> */}
                        <Box data-error={touched.phone && errors.phone ? "true" : undefined}>
                          <PhoneInput
                            specialLabel=""
                            country="us"
                            enableSearch
                            value={values?.phone}
                            onChange={(phone) => setFieldValue("phone", "+" + phone)}
                            onBlur={() => setFieldTouched("phone", true)}
                            inputProps={{
                              name: "phone",
                              "aria-invalid": Boolean(touched.phone && errors.phone),
                            }}
                            inputStyle={{
                              width: "100%",
                              height: "32px",
                              borderColor:
                                touched.phone && errors.phone ? "#d32f2f" : undefined,
                              boxShadow:
                                touched.phone && errors.phone
                                  ? "0 0 0 1px #d32f2f"
                                  : undefined,
                            }}
                          />
                        </Box>
                        <span
                          style={{
                            fontWeight: 400,
                            fontSize: '0.75rem',
                            lineHeight: 1.66,
                            letterSpacing: '0.03333em',
                            textAlign: 'left',
                            marginTop: '4px',
                            marginRight: '14px',
                            marginBottom: '0',
                            marginLeft: '14px',
                            color: '#FF3D57',
                          }}
                        >
                          {Boolean(touched.phone && errors.phone)
                            ? touched.phone && errors.phone
                            : null}
                        </span>
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Email<span style={{ color: "red" }}>*</span>
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="email"
                          {...getFieldProps("email")}
                          error={Boolean(touched.email && errors.email)}
                          helperText={touched.email && errors.email}
                        />
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Do you have parking spot?
                        </h3>
                        <TextField
                          fullWidth
                          type="text"
                          select
                          size="small"
                          value={values.do_parking_spot}
                          name='do_parking_spot'
                          onChange={(e) => setFieldValue('do_parking_spot', e.target.value)}
                          error={Boolean(touched.do_parking_spot && errors.do_parking_spot)}
                          helperText={touched.do_parking_spot && errors.do_parking_spot}
                        >
                          <MenuItem value={true}>Yes</MenuItem>
                          <MenuItem value={false}>No</MenuItem>
                        </TextField>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          How did you hear about us? (Optional)
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="text"
                          select
                          {...getFieldProps("hear_about_us")}
                          error={Boolean(
                            touched.hear_about_us && errors.hear_about_us
                          )}
                          helperText={
                            touched.hear_about_us && errors.hear_about_us
                          }
                        >
                          {findUsList?.length ? findUsList?.map((item) => {
                            return (
                              <MenuItem value={item?.title} key={item?.id}>
                                {item?.title}
                              </MenuItem>
                            );
                          }) : (
                            <MenuItem disabled>No options available</MenuItem>
                          )}
                        </TextField>
                      </Grid>
                      <Grid item lg={6} md={6} sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Promo Code (Optional)
                        </h3>
                        <TextField
                          size="small"
                          fullWidth
                          type="text"
                          {...getFieldProps("promo_code")}
                          error={Boolean(
                            touched.promo_code && errors.promo_code
                          )}
                          helperText={touched.promo_code && errors.promo_code}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={2}
                        sx={{ display: "flex", alignItems: "end" }}
                      >
                        <Button
                          variant="contained"
                          onClick={handleValidatePromo}
                        >
                          Apply
                        </Button>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Button
                          style={{ marginTop: "30px" }}
                          onClick={() => setGiftCardCodeModal(true)}
                        >
                          Validate Gift Card Code
                        </Button>
                      </Grid>
                    </Grid>
                    <Divider sx={{ marginTop: "2rem" }} />
                    <Typography variant="h6" className="subHeadings">
                      How Will We Get In?
                    </Typography>
                    <Grid container rowSpacing={2} columnSpacing={5}>
                      <Grid item sm={12} xs={12}>
                        {/* <TextField
                          size="small"
                          multiline
                          rows={5}
                          fullWidth
                          type="text"
                          inputProps={{ placeholder: 'How Will We Get In?' }}
                          {...getFieldProps('how_to_enter_on_premise')}
                          error={Boolean(
                            touched.how_to_enter_on_premise && errors.how_to_enter_on_premise
                          )}
                          helperText={
                            touched.how_to_enter_on_premise && errors.how_to_enter_on_premise
                          }
                        /> */}
                        <TextField
                          fullWidth
                          type="text"
                          select
                          {...getFieldProps("how_to_enter_on_premise")}
                          error={Boolean(
                            touched.how_to_enter_on_premise &&
                            errors.how_to_enter_on_premise
                          )}
                          helperText={
                            touched.how_to_enter_on_premise &&
                            errors.how_to_enter_on_premise
                          }
                        >
                          <MenuItem value={"ill be home"}>
                            I'll be at home
                          </MenuItem>
                          <MenuItem value={"key with doorman"}>
                            The key is with doorman
                          </MenuItem>
                          <MenuItem value={"lockbox on premises"}>
                            Lockbox on premises
                          </MenuItem>
                          <MenuItem value={`I'll call/email to organize`}>
                            Call to organize
                          </MenuItem>
                          <MenuItem value={"Other"}>Other</MenuItem>
                        </TextField>
                      </Grid>
                    </Grid>
                    <Divider sx={{ marginTop: "2rem" }} />
                    <Typography
                      variant="h6"
                      className="subHeadings"
                      style={{ paddingBottom: "0px" }}
                    >
                      Are there any addtional details we need to know?
                    </Typography>
                    <Typography
                      variant="body1"
                      style={{ paddingBottom: "1rem" }}
                    >
                      You can email us at support@bookcleany.com with photos,
                      floorplan or anyother relevent informations
                    </Typography>
                    <Grid container rowSpacing={2} columnSpacing={5}>
                      <Grid item sm={12} xs={12}>
                        <h3 style={{ marginTop: "unset", marginBottom: "5px" }}>
                          Additional Information
                          <span style={{ color: "red" }}></span>
                        </h3>
                        <TextField
                          size="small"
                          multiline
                          rows={5}
                          fullWidth
                          type="text"
                          inputProps={{
                            placeholder: "Additional information...",
                          }}
                          {...getFieldProps("additional_info")}
                          error={Boolean(
                            touched.additional_info && errors.additional_info
                          )}
                          helperText={
                            touched.additional_info && errors.additional_info
                          }
                        />
                      </Grid>
                    </Grid>
                    <Divider sx={{ marginTop: "2rem" }} />

                    {/* <Grid container rowSpacing={2} columnSpacing={5}>
                      <Grid item sm={12} xs={12}>
                        <h3 style={{ marginTop: '1rem', marginBottom: '5px' }}>
                          Customer Notes<span style={{ color: 'red' }}></span>
                        </h3>
                        <TextField
                          size="small"
                          multiline
                          rows={5}
                          fullWidth
                          type="text"
                          inputProps={{ placeholder: 'Customer notes...' }}
                          {...getFieldProps('customer_notes')}
                          error={Boolean(touched.customer_notes && errors.customer_notes)}
                          helperText={touched.customer_notes && errors.customer_notes}
                        />
                      </Grid>
                    </Grid>
                    <Divider sx={{ marginTop: '2rem' }} /> */}
                    <Typography
                      variant="h4"
                      className="subHeadings"
                      sx={{ textAlign: "start !important" }}
                    >
                      Step 6: Payment Details
                    </Typography>
                    {/* <Typography
                      variant="body1"
                      style={{ paddingBottom: '1rem', textAlign: 'start' }}
                    >
                      First apply card then click on book now!
                    </Typography> */}
                    <Grid container sx={{
                      marginBottom: '15px'
                    }}>
                      <Grid item flexGrow={1}>
                        <Box sx={{
                          padding: '10px',
                          backgroundColor:
                            selectedMethod === 'stripe'
                              ? "#3498db1A"
                              : "#f9f9fb",
                          border: `1px solid ${selectedMethod === 'stripe' ? "#1976d2" : "#ddd"}`,
                          cursor: 'pointer',
                        }} onClick={() => {
                          setSelectedMethod('stripe');
                        }}>Stripe</Box>
                      </Grid>
                      <Grid item flexGrow={1}>
                        <Box sx={{
                          padding: '10px',
                          backgroundColor:
                            selectedMethod === 'zelle'
                              ? "#3498db1A"
                              : "#f9f9fb",
                          border: `1px solid ${selectedMethod === 'zelle' ? "#1976d2" : "#ddd"}`,
                          cursor: 'pointer',
                        }} onClick={() => {
                          setSelectedMethod('zelle');
                        }}>Zelle</Box>
                      </Grid>
                    </Grid>
                    {selectedMethod === 'stripe' ? <>
                      <Elements stripe={stripePromise}>
                        <ElementsConsumer>
                          {({ stripe, elements }) => (
                            <>
                              <Box
                                sx={{
                                  marginBottom: "10px",
                                }}
                              >
                                <TextField
                                  size="medium"
                                  fullWidth
                                  type="text"
                                  inputProps={{ placeholder: "Name (Required)" }}
                                  value={values.cardHolderName}
                                  onChange={(e) =>
                                    setFieldValue(
                                      "cardHolderName",
                                      e.target.value
                                    )
                                  }
                                  error={Boolean(
                                    touched.cardHolderName &&
                                    errors.cardHolderName
                                  )}
                                  helperText={
                                    touched.cardHolderName &&
                                    errors.cardHolderName
                                  }
                                />
                              </Box>
                              <Box
                                sx={{
                                  borderRadius: "4px",
                                  border: Boolean(errors.card_token)
                                    ? "1px solid #e5424d"
                                    : "1px solid rgba(0, 0, 0, 0.23);",
                                }}
                              >
                                <CardElement
                                  options={CARD_ELEMENT_OPTIONS}
                                  onReady={(element) => {
                                    setElements(elements);
                                  }}
                                  onChange={(event) => {
                                    setStripe(stripe);
                                  }}
                                />
                              </Box>
                              {Boolean(errors.card_token) && (
                                <Box
                                  sx={{
                                    color: "#FF3D57",
                                    fontWeight: "400",
                                    fontSize: "0.75rem",
                                    letterSpacing: "0.03333em",
                                    marginTop: "4px",
                                    marginBottom: "0",
                                    marginLeft: "14px",
                                  }}
                                >
                                  {errors.card_token}
                                </Box>
                              )}
                              {/* <Box textAlign={'center'} paddingTop="1rem">
                              <Button
                                variant="contained"
                                color="inherit"
                                onClick={() => handleCardSubmit(stripe, elements)}
                                disabled={values?.card_token === '' ? false : true}
                              >
                                Apply Card
                              </Button>
                            </Box> */}
                              <Typography
                                fontSize={"14px"}
                                color={"#8a94a9"}
                                marginTop={"20px"}
                              >
                                I authorize the operator to send instructions to
                                the financial institution that issued my card to
                                take payments from my card account in accordance
                                with the terms of my agreement with you.
                              </Typography>
                            </>
                          )}
                        </ElementsConsumer>
                      </Elements>
                    </> : <>
                      <Box

                        padding={"5px 20px"}
                        backgroundColor={"#f9f9fb"}
                        border={`1px solid #ddd`}
                        borderRadius={"5px"}
                        textAlign={'left'}
                      >
                        <p>Send <span>${finalTotal.toFixed(2)}</span> via <a style={{ color: '#6d1fd4' }} rel="noreferrer" href="https://zellepay.com/" target="_blank">Zelle</a> or from your bank.</p>
                        <p>Here are the Zelle details you should know for the transfer</p>
                        <p>Zelle Name: <br />Zelle Email: <strong>{''}</strong><br />Zelle Phone: </p>
                        <p>Please <strong>use your Order Number (available once you place order)</strong> as the payment reference.</p><p><strong>After paying, please come back here and place the order below</strong> so we can start processing your order.</p>
                      </Box>
                    </>}
                    <FormGroup sx={{ marginTop: "2rem" }}>
                      <FormControlLabel
                        control={<Checkbox defaultChecked />}
                        label="By competing this booking, I understand that I am purchasing a onetime or reccuring service subject to Cleany's Policies and Terms Of Service and my payment method will be charged before each booking."
                      />
                    </FormGroup>
                    <LoadingButton
                      type="submit"
                      size="large"
                      color="primary"
                      loading={loading}
                      disabled={loading}
                      variant="contained"
                      sx={{ mb: 2, mt: 3 }}
                      fullWidth

                    >
                      Book Now
                    </LoadingButton>
                  </Box>
                </Form>
              </FormikProvider>
            </Box>
            <Box
              sx={{
                background: "white",
                padding: "1rem",
                paddingTop: "2rem",
                width: "100%",
                border: "1px solid #dddada",
                marginTop: "4rem",
                marginBottom: "4rem",
                "& h4": {
                  textAlign: "start !important",
                  paddingBottom: "2rem !important",
                },
              }}
            >
              <Typography variant="h4" className="bookingTitle">
                Here’s why Cleany is different
              </Typography>
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChangeAccordian("panel1")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography sx={{ fontSize: "16px" }}>
                    Instant online booking with live customer support 7am-11pm
                    availability
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={{ fontSize: "16px" }}>
                    Ordering a professional cleaning service with Cleany is
                    simple as 1-2-3. Our online booking platform makes it easy
                    to book with our cleaning packages and individual add ons.
                    We take great pride in our customer service and we are
                    available by phone or email during the week from 7 am - 11
                    pm and similar hours on weekends for your questions and
                    requests.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChangeAccordian("panel2")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography sx={{ fontSize: "16px" }}>
                    We bring all the cleaning supplies
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={{ fontSize: "16px" }}>
                    You read that right! We use and provide environmentally
                    friendly supplies (besides our EPA-registered disinfectants
                    & heavy duty products). We DO bring a vacuum, swiffer or
                    microfiber mop & natural cleaning products to name a few. We
                    DON’T bring a ladder or step stool, toilet brush or pest
                    control products. For any special requests please reach out
                    at least 24 hours prior to scheduled appointment.
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel3"}
                onChange={handleChangeAccordian("panel3")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography sx={{ fontSize: "16px" }}>
                    The Cleany Happiness Guarantee
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={{ fontSize: "16px" }}>
                    We want you to be happy and satisfied with every cleaning
                    service we provide. That's why we have the Cleany Happiness
                    Guarantee for every appointment! If for any reason you are
                    not satisfied with your results, We will expedite a free
                    reclean around your next availibility. You can book with
                    confidence with Cleany.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Box
              sx={{
                position: { xs: "static", md: "sticky" },
                top: { md: "8rem" },
                maxHeight: { md: "calc(100vh - 9rem)" },
                overflowY: { md: "auto" },
                overflowX: "hidden",
                pr: { md: 0.5 },
                scrollbarWidth: "thin",
                "&::-webkit-scrollbar": { width: "6px" },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#c4cfdb",
                  borderRadius: "6px",
                },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  background: "white",
                  padding: "1rem",
                  paddingTop: "1rem",
                  paddingBottom: "1rem",
                  border: "1px solid #dddada",
                }}
              >
                <Typography
                  variant="h6"
                  style={{ paddingBottom: "0.2rem" }}
                  className="subHeadings"
                >
                  {values?.frequency === "once" && "One Time Cleaning Plan"}
                  {values?.frequency === "weekly" && "Weekly Cleaning Plan"}
                  {values?.frequency === "biweekly" && "Biweekly Cleaning Plan"}
                  {values?.frequency === "monthly" && "Monthly Cleaning Plan"}
                </Typography>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {/* {frequency !== 'once' && (
                  <Typography variant="body1" style={{ fontSize: '1rem' }}>
                    6 Months
                  </Typography>
                )} */}
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Date & Time:{" "}
                  </Typography>
                  <Typography variant="body1">
                    {values.start_date
                      ? moment(values.start_date).format("MMMM DD, YYYY")
                      : ""}{" "}
                    -{" "}
                    {availableTimes.find((z) => z.value === values?.start_time)
                      ?.label || ""}
                  </Typography>
                </div>
                <Divider sx={{ marginTop: "1rem", marginBottom: "1rem" }} />
                <BookingSelectionBreakdown
                  selectedItems={selectedBookingItems}
                  selectedExtras={selectedBookingExtras}
                  availableExtras={bookingData?.extras || []}
                />
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent="space-between"
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Required time
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    {Number(totalHours.toFixed(2))} hrs
                  </Typography>
                </Box>
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"space-between"}
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Per cleaning
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    $
                    {itemSubtotal.toFixed(2)}
                  </Typography>
                </Box>
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"space-between"}
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Discounts
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    $
                    {itemDiscountTotal.toFixed(2)}
                  </Typography>
                </Box>
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"space-between"}
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Extras
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    $
                    {extrasTotal.toFixed(2)}
                  </Typography>
                </Box>
                {/* <Box
                  display={'flex'}
                  alignItems="center"
                  justifyContent={'space-between'}
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: '1rem' }}>
                    Tax Rate
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: '1rem' }}>
                    {bookingData?.tax?.[0]?.tax_rate}%
                  </Typography>
                </Box> */}
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"space-between"}
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Estimated Tax
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    ${estimatedTax ? estimatedTax?.toFixed(2) : 0}
                  </Typography>
                </Box>
                {promoDiscount && (
                  <Box
                    display={"flex"}
                    alignItems="center"
                    justifyContent={"space-between"}
                    paddingBottom="1rem"
                  >
                    <Typography variant="body1" style={{ fontSize: "1rem" }}>
                      Promo Code Discount
                    </Typography>
                    <Typography variant="body1" style={{ fontSize: "1rem" }}>
                      ${promoDiscount ? promoDiscount?.toFixed(2) : 0}
                    </Typography>
                  </Box>
                )}
                {giftCardDiscount && (
                  <Box
                    display={"flex"}
                    alignItems="center"
                    justifyContent={"space-between"}
                    paddingBottom="1rem"
                  >
                    <Typography variant="body1" style={{ fontSize: "1rem" }}>
                      Gift Card Discount
                    </Typography>
                    <Typography variant="body1" style={{ fontSize: "1rem" }}>
                      ${giftCardDiscount ? giftCardDiscount?.toFixed(2) : 0}
                    </Typography>
                  </Box>
                )}
                <Divider sx={{ marginTop: "1rem", marginBottom: "1rem" }} />
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"space-between"}
                >
                  <Typography
                    variant="h6"
                    className="subHeadings"
                    style={{ paddingTop: "unset" }}
                  >
                    TODAY'S TOTAL
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    $
                    {finalTotal.toFixed(2)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Dialog
        open={giftCardCodeModal}
        onClose={() => setGiftCardCodeModal(false)}
        maxWidth={"sm"}
        PaperProps={{
          sx: {
            width: "100%",
          },
        }}
        aria-labelledby="package-item"
        aria-describedby="package-item-description"
      >
        <DialogTitle id="package-item" style={{ fontSize: "1.5rem" }}>
          Validate Gift Card Code
        </DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                type="text"
                inputProps={{ placeholder: "Gift Card Code" }}
                value={giftCardCode}
                onChange={(e) => setGiftCardCode(e.target.value)}
              />
            </Grid>
          </Grid>
          <Box
            display={"flex"}
            alignItems="center"
            justifyContent={"end"}
            sx={{ mb: 2, mt: 3 }}
          >
            <Button
              onClick={() => {
                setGiftCardCodeModal(false);
              }}
              variant="outlined"
              color="primary"
              sx={{ mr: 2 }}
            >
              Cancel
            </Button>
            <LoadingButton
              onClick={handleValidateGiftCard}
              color="primary"
              loading={loading}
              variant="contained"
            >
              Apply
            </LoadingButton>
          </Box>
        </DialogContent>
      </Dialog>
      <Toaster position="top-right" />
    </MainBox>
  );
}

export default Booking;
